import { render, staticRenderFns } from "./childEdit.vue?vue&type=template&id=af7a7af8&scoped=true&"
import script from "./childEdit.vue?vue&type=script&lang=js&"
export * from "./childEdit.vue?vue&type=script&lang=js&"
import style0 from "./childEdit.vue?vue&type=style&index=0&id=af7a7af8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7a7af8",
  null
  
)

export default component.exports